import { useEffect, RefObject } from 'react';

const useMutationObserver = (
  targetRef: RefObject<Element>,
  callback: MutationCallback,
  options: MutationObserverInit = {
    attributes: true,
    childList: true,
    subtree: true,
  },
) =>
  useEffect(() => {
    const targetNode = targetRef?.current;
    if (!targetNode) return undefined;

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, options);

    return () => {
      observer.disconnect();
    };
  }, [targetRef, callback, options]);

export default useMutationObserver;
